<script setup lang="ts">
import { CookieRef } from "#app";
import { ISessionLimitCookie } from "~/types/responsible-gaming/responsible-gaming";
import t from "~/utils/translate";
import { useSessionLimit, resetTimer, clearTimer } from "~/composables/useSessionLimit";
import { useAuth } from "~/store/auth";

const auth = useAuth();
const router = useRouter();
const route = useRoute();
const sessionLimitCookie: CookieRef<ISessionLimitCookie> = useCookie("session_limit");
const showSessionModal = useSessionLimit();

const intervalText = computed(() => {
	if (sessionLimitCookie.value) {
		return t("responsible-gaming-reality-check-body.interval").replace(`%{periodInterval}`, sessionLimitCookie.value.periodValue.toString());
	}
});


const handleGoToAccount = () => {
  router.push({ query: { ...route.query, account: 'responsible-gaming' } })
  resetTimer()
  showSessionModal.value = false
}
</script>

<template>
	<UiModal
		:active="showSessionModal && auth.hydrated"
		:disableClose="true"
		:title="t('responsible-gaming-reality-check-heading')"
		size="small"
		rootClass="z-[100] text-xs leading-4"
	>
		<div class="mb-4">
			{{ t("responsible-gaming-reality-check-body.start") }}
			<span class="text-bold text-primary-500">{{ intervalText }}</span>
			{{ t("responsible-gaming-reality-check-body.end") }}
		</div>
		<div class="mb-4">
			{{ t("responsible-gaming-reality-check-review") }}
			<a @click="handleGoToAccount" class="cursor-pointer text-primary-500">{{
				t("account-settings")
			}}</a>
		</div>
		<div>{{ t("responsible-gaming-reality-check-question") }}</div>
		<template #footer>
			<div class="flex justify-between w-full gap-4">
				<UiButton
					:label="t('logout')"
					variant="secondary"
					class="w-full"
					@click="
						() => {
							auth.logout();
							router.push({});
							clearTimer();
						}
					"
				/>
				<UiButton :label="t('responsible-gaming-reality-check-keep-playing')" class="w-full" variant="identity" @click="resetTimer()" />
			</div>
		</template>
	</UiModal>
</template>

<style scoped lang="scss"></style>
